<template>
  <div class="ui left aligned container">
    <div class="ui right aligned container">
        <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
    </div>
    <vuetable ref="vuetable"
        :api-url="'/albums?albumid=' + albumid"
        :fields="fields"
        data-path="albums"
        @vuetable:load-success="dataLoaded($event)"
    >
      <template slot="avg" slot-scope="props">
        {{(props.rowData.totalCount / props.rowData.totalPeople).toFixed(2)}}
      </template>
    </vuetable>
    <br>
    <div v-if="count">总助燃次数：{{count}}</div>
    <div v-if="total">总购买次数：{{total}}</div>
    <div v-if="total">未助燃次数：{{total - count}}</div>
    <div v-if="time">统计时间：{{time}}</div>

  </div>
</template>
<style>
</style>
<script>
  import Vuetable from '../../table/Vuetable.vue'
  import VuetablePagination from '../../table/VuetablePagination.vue'
  import VuetablePaginationInfo from '../../table/VuetablePaginationInfo.vue'

  export default {
    name: 'AlbumList',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    data () {
      return {
        count: '',
        total: '',
        time: '',
        albumid: this.$route.params.id || 4359159,
        fields: [
          {name: 'name', title: '姓名', sortField: 'id', callback: 'link'},
          {name: 'newPeople', title: '今日新增人数', sortField: 'newPeople'},
          {name: 'todayPeople', title: '今日助燃人数', sortField: 'todayPeople'},
          {name: 'todayCount', title: '今日助燃次数', sortField: 'todayCount'},
          {name: 'totalPeople', title: '总助燃人数', sortField: 'totalPeople'},
          {name: 'totalCount', title: '总助燃次数', sortField: 'totalCount'},
          {name: '__slot:avg', title: '人均助燃次数'}
        ]
      }
    },
    beforeRouteUpdate (to, from, next) {
      this.albumid = to.params.id;
      next();
    },
    methods: {
      dataLoaded: function (event) {
        this.total = event.data.total;
        this.count = event.data.count;
        this.time = new Date(event.data.time).toLocaleString();
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      link: function (value, item) {
        if (item.singerid > 100000000) {
          return '<a href="https://y.qq.com/m/digitalbum/gold/index.html?_video=true&id='+this.albumid+'#groupsongcall_v2/'
            + item.singerid + '" target="_blank">' + value + '</a>';
        } else {
          return '<a href="https://y.qq.com/m/digitalbum/gold/index.html?_video=true&id='+this.albumid+'#singercall/'
            + item.singerid + '" target="_blank">' + value + '</a>';
        }
      }
    }
  }
</script>
